import {
  externalQuoteRedirects,
  type LocationProps
} from './data'

export const stripQueryParameters = (path: string) => path.replace(/:[^/]+/, '')

export const getExternalQuoteUrl = (location: LocationProps | undefined): string | undefined => (
  location ? externalQuoteRedirects[location.siteId] : undefined
)
